import { render, staticRenderFns } from "./AiBuddyDrawer.vue?vue&type=template&id=9002283c&scoped=true"
import script from "./AiBuddyDrawer.vue?vue&type=script&lang=js"
export * from "./AiBuddyDrawer.vue?vue&type=script&lang=js"
import style0 from "./AiBuddyDrawer.vue?vue&type=style&index=0&id=9002283c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9002283c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9002283c')) {
      api.createRecord('9002283c', component.options)
    } else {
      api.reload('9002283c', component.options)
    }
    module.hot.accept("./AiBuddyDrawer.vue?vue&type=template&id=9002283c&scoped=true", function () {
      api.rerender('9002283c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue"
export default component.exports